import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function STHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-2010">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/1CMBk7JRpP4WbL4w8U13PE/Skintyte.jpg)'
    }} data-id="element-2011" />
      <div className="absolute inset-0 bg-black/60" data-id="element-2012" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-2013">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-2014">
          <div className="mb-6" data-id="element-2015">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-2016">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-2017">
                Treatments
              </a>{' '}
              / Lasers
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2018">
            Be DARING
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-2019">
            SKINTYTE LASER
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8" data-id="element-2020">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-2021">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2022">
              Want lifted, tighter skin without ANY discomfort or downtime?
              SkinTyte is the perfect laser treatment for you!
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2023">
              SkinTyte uses light energy to heat and stimulate your skin cells
              and make your skin tighter because it stimulates the body's
              natural collagen production. The result is the appearance of
              smoother, firmer, and tighter skin with a more youthful tone. At
              Be CLINICAL, we are proud to offer this revolutionary technology
              to our patients.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-2024">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}